// Module
var code = " <gb-button icon=\"add\" ng-click=\"$ctrl.addWidget()\"> <span translate=\"ADD_RAFFLE_DRAW_WIDGET_BUTTON\"></span> </gb-button> <gb-edit-raffle-draw-widget widget=\"$ctrl.widget\"></gb-edit-raffle-draw-widget> ";
// Exports
export default code;